export const PRODUCT_CATEGORIES: { name: string; items: string[] }[] = [
  {
    name: "Tissue Repair & Recovery",
    items: [
      "BPC-157",
      "BPC-157 (oral / arginate form)",
      "TB-500 (Thymosin Beta-4)",
      "GHK-Cu (Copper Peptide)",
      "KPV",
      "LL-37",
      "Thymalin",
      "Thymosin Alpha-1 (Ta1)",
      "AOD-9604",
      "SNAP-8",
      "Larazotide",
      "Desmopressin",
    ],
  },
  {
    name: "Growth Hormone & Anti-Aging",
    items: [
      "Ipamorelin",
      "CJC-1295 (no DAC)",
      "CJC-1295 (with DAC)",
      "GHRP-2",
      "GHRP-6",
      "Sermorelin",
      "Tesamorelin",
      "Hexarelin",
      "MK-677 (Ibutamoren)",
      "Epithalon (Epitalon)",
      "IGF-1 (standard)",
      "IGF-1 LR3",
      "MGF (Mechano Growth Factor)",
    ],
  },
  {
    name: "Metabolic, Weight & GLP-1",
    items: [
      "Semaglutide",
      "Tirzepatide",
      "Retatrutide",
      "Liraglutide",
      "MOTS-c",
      "5-Amino-1MQ",
      "AOD-9604 (metabolic focus)",
      "Insulin (compounded)",
      "Other GLP-1 / GIP Analog",
    ],
  },
  {
    name: "Cognitive & Neurological",
    items: [
      "Semax",
      "Selank",
      "Dihexa",
      "P21",
      "Cerebrolysin",
      "Pinealon",
      "Cortagen",
      "VIP (Vasoactive Intestinal Peptide)",
      "DSIP (Delta Sleep-Inducing Peptide)",
      "Noopept",
    ],
  },
  {
    name: "Longevity & Cellular Health",
    items: [
      "Humanin",
      "SS-31 (Elamipretide)",
      "FOXO4-DRI",
      "Klotho",
      "NAD+ (IV / injectable)",
      "NMN (pharmaceutical grade)",
      "NR (Nicotinamide Riboside)",
      "Rapamycin (compounded)",
      "Vilon (Lys-Glu)",
      "Vesugen (vascular bioregulator)",
    ],
  },
  {
    name: "Russian Bioregulator Peptides (Khavinson)",
    items: [
      "Sigumir (cartilage / joints)",
      "Cartalax (cartilage)",
      "Crystagen (immune)",
      "Testagen (testosterone support)",
      "Ovagen (ovarian)",
      "Prostamax (prostate)",
      "Retinalamin (retinal / eye)",
      "Cerluten (brain / CNS)",
      "Other Khavinson Bioregulator",
    ],
  },
  {
    name: "Sexual Health & Hormone Support",
    items: [
      "PT-141 (Bremelanotide)",
      "Kisspeptin",
      "Oxytocin (compounded)",
      "Gonadorelin / GnRH",
      "HCG (Human Chorionic Gonadotropin)",
      "Testosterone (compounded)",
      "Estradiol (compounded)",
      "Progesterone (compounded)",
      "Tadalafil (compounded)",
      "DHEA (compounded)",
    ],
  },
  {
    name: "Immune & Anti-Inflammatory",
    items: [
      "Thymosin Alpha-1 (immune focus)",
      "KPV (gut / anti-inflammatory)",
      "LL-37 (antimicrobial)",
      "BPC-157 (gut / immune)",
      "Thymulin",
      "Splenopentin",
      "Thymosin Beta-4 Fragment (immune)",
    ],
  },
  {
    name: "Skin, Aesthetic & Hair",
    items: [
      "GHK-Cu (topical)",
      "Argireline (Acetyl Hexapeptide-3)",
      "Matrixyl (Palmitoyl Pentapeptide)",
      "Leuphasyl",
      "Melanotan II",
      "Melanotan I (Afamelanotide)",
      "Hair Peptide Complexes",
      "PTD-DBM / Regenerative Hair Peptides",
      "Other Aesthetic Peptides",
    ],
  },
  {
    name: "Performance & Muscle",
    items: [
      "Follistatin FST-344",
      "PEG-MGF",
      "ACE-031",
      "BPC-157 (performance / tendon)",
      "TB-500 (performance / recovery)",
      "Thymosin Beta-4 (sports recovery)",
    ],
  },
  {
    name: "IV Nutrients & Adjuncts",
    items: [
      "Glutathione (IV push)",
      "Vitamin C (high-dose IV)",
      "Alpha Lipoic Acid (IV)",
      "Myers' Cocktail base",
      "Phosphatidylcholine (IV)",
      "NAD+ (IV drip, high-dose)",
      "Thyroid (compounded T3/T4)",
      "Other IV compound / nutrient",
    ],
  },
  {
    name: "Biologics - Exosomes & Stem Cells",
    items: [
      "MSC-Derived Exosomes (IV-grade)",
      "Extracellular Matrix (EXM)",
      "MSC Secretomes (EXS)",
      "Umbilical Cord MSCs",
      "Wharton's Jelly",
      "Amniotic Membrane",
      "Platelet-Rich Plasma (PRP kits)",
      "Growth Factors (EGF, FGF, VEGF)",
    ],
  },
  {
    name: "Botanicals, Adaptogens & Other",
    items: [
      "Adaptogenic APIs",
      "Custom Formulation / White-Label",
      "Other - not listed above",
    ],
  },
];

export function catField(name: string) {
  return `products_${name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")}`;
}
